const eyemovement = {
  state: {
    moveMode: '随机', // 运动方式,随机=>乱动,逆时针,顺时针,综合
    speed: 1, // 运动速度
    // 半径
    // 随机:
  },
  mutations: {
    UPDATE_EYEMOVEMENT: (state, config) => {
      // state.sight = config
      Object.assign(state.eyemovement, config)
    },
  },
  actions: {},
  getters: {},
}

export default eyemovement
